<div class="padding">
  <mat-card>
    <mat-card-content>
      <div class="table-container">
        <div class="flex-container-space-between">
          <h3>{{ 'batchSummaries.batchesOverview' | transloco }}</h3>
          <mat-checkbox [(ngModel)]="includeCompleted" (change)="isCompletedFilterChange()">
            {{ 'batchSummaries.showCompleted' | transloco }}
          </mat-checkbox>
        </div>

        <!-- Databases overview table -->
        @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
          <table mat-table [dataSource]="this.repo.resource$" multiTemplateDataRows
            >
            <ng-container matColumnDef="batchType">
              <th mat-header-cell *matHeaderCellDef id="batchType"> {{ 'common.labels.type' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary"> {{ batchSummary.batchTypeID | enumLabel:'batchType' }} </td>
            </ng-container>
            <ng-container matColumnDef="batchState">
              <th mat-header-cell *matHeaderCellDef id="batchState"> {{ 'common.labels.state' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary"> {{ batchSummary.batchStateID | enumLabel:'batchState' }} </td>
            </ng-container>
            <ng-container matColumnDef="draftOrders">
              <th mat-header-cell *matHeaderCellDef id="draftOrders"> {{ 'batchSummaries.draft' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary">
                <button mat-raised-button [disabled]="batchSummary.draftOrders === 0"
                  [ngStyle]="getButtonColor(batchSummary.draftOrders)"
                  (click)="onViewDraftOrders(batchSummary)">
                  {{ batchSummary.draftOrders }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="pendingOrders">
              <th mat-header-cell *matHeaderCellDef id="pendingOrders"> {{ 'batchSummaries.pending' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary">
                <button mat-raised-button [disabled]="batchSummary.pendingOrders === 0"
                  [ngStyle]="getButtonColor(batchSummary.pendingOrders)"
                  (click)="onViewPendingOrders(batchSummary)">
                  {{ batchSummary.pendingOrders }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="completedOrders">
              <th mat-header-cell *matHeaderCellDef id="completedOrders"> {{ 'batchSummaries.completed' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary">
                <button mat-raised-button [disabled]="batchSummary.completedOrders === 0"
                  color="primary"
                  (click)="onViewCompletedOrders(batchSummary)">
                  {{ batchSummary.completedOrders }}
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="totalOrders">
              <th mat-header-cell *matHeaderCellDef id="totalOrders"> {{ 'common.labels.total2' | transloco }} </th>
              <td mat-cell *matCellDef="let batchSummary">
                <button mat-raised-button [disabled]="batchSummary.totalOrders === 0"
                  color="primary"
                  (click)="viewBatch(batchSummary)">
                  {{ batchSummary.totalOrders }}
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }

        @if ((repo.resourceCount$ | async) ?? 0 > pageSize) {
          <mat-paginator [hidePageSize]="true"
            [pageSize]="pageSize" [length]="this.repo.resourceCount$ | async"
            [pageIndex]="this.repo.pageNum$ | async" showFirstLastButtons="true"
          (page)="page($event)"></mat-paginator>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>